import { render, staticRenderFns } from "./HistoryMenus.vue?vue&type=template&id=535e903c&scoped=true"
import script from "./HistoryMenus.vue?vue&type=script&lang=js"
export * from "./HistoryMenus.vue?vue&type=script&lang=js"
import style0 from "./HistoryMenus.vue?vue&type=style&index=0&id=535e903c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535e903c",
  null
  
)

export default component.exports